import { useConfirm } from "material-ui-confirm";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import LabelsContext from "../../../lang/LabelsContext";
import MessageType from "../../../utils/MessageType";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface ReviewerSelectionServiceType {
  article: any;
  confirmSendToAssistant: any;
}

export default function ReviewerSelectionService(): ReviewerSelectionServiceType {
  const { showMessage, setBlockUI } = useAppContext();
  const { axiosGetArticleById, axiosPostReturnToAssistant }: ArticleControllerType = ArticleController();
  const { id }: any = useParams();
  const [article, setArticle] = useState<any>({});
  const { Labels } = LabelsContext();

  const history = useHistory();

  const confirm = useConfirm();

  useEffectOnce(() => {
    getArticleById(id);
  });

  const getArticleById = (id: number) => {
    axiosGetArticleById(id)
      .then((result: any) => setArticle(result.data))
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const returnToAssistantEditor = () => {
    setBlockUI(true);
    axiosPostReturnToAssistant(id)
      .then((result: any) => {
        showMessage("Article is returned to assistant editor.", MessageType.SUCCESS);
        history.push("/toDoList");
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      })
      .finally(() => setBlockUI(false));
  };

  const confirmSendToAssistant = () => {
    return confirm({
      description: "Are you sure you want forward paper to Assistant editor?",
      confirmationText: Labels.YES,
      cancellationText: Labels.NO,
      confirmationButtonProps: {
        variant: "contained",
        color: "primary",
      },
    })
      .then(returnToAssistantEditor)
      .catch(() => {});
  };

  return {
    article,
    confirmSendToAssistant,
  };
}
export type { ReviewerSelectionServiceType };
